import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, description, testId }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-gold-soft/90">
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        data-testid={testId}
        className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-50 leading-[1.12]"
      >
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{description}</p>
      </Reveal>
    )}
    <Reveal delay={0.2}>
      <div className="mt-8 gold-hairline w-40" />
    </Reveal>
  </div>
);
